module.exports = __webpack_public_path__ + "static/media/p-bank-card-background.873cee6f.svg";